// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#footer_sec {
    width: 100%;
    background: #C7D9F9;
}

.footer_content {
    max-width: 1000px;
    width: 100%;
    margin: auto;
}

.logo_icon p {
    text-align: center;
    color: #3D4F71; 
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
}

.footer_Search .btn-primary {
    border-radius: 0px 10px 10px 0px !important; 
    background: #163873 !important;
    color: #FFF;
    border: none;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    width: 150px;
    height: 50px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.footer_Search .form-control {
    height: 50px;
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
    color: var(--Gray-1, #808282);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.input_group_footer {
    max-width: 599px;
}

.footer_Search .btn:hover {
    border: none;
    background-color: #000;
    color: #fff;
}

.footer_link h3 {
    color: var(--Black, #010404);
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
}

.footer_link ul {
    padding: 0;
    margin-top: 20px;
}

.footer_link ul li a {
    color: #3D4F71;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    text-transform: capitalize;
}

.footer_bottom {
    background: #B9CBEB;
    height: 50px;
}

.footer_bottom span {
    color: #163873;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

@media (max-width: 991.98px) {
    .footer_bottom {
        height: auto;
        padding: 5px;
    }

    .footer_link {
        text-align: center;
    }

}
`, "",{"version":3,"sources":["webpack://./src/components/userpenal/styles/style-footer.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;AAEJ","sourcesContent":["#footer_sec {\n    width: 100%;\n    background: #C7D9F9;\n}\n\n.footer_content {\n    max-width: 1000px;\n    width: 100%;\n    margin: auto;\n}\n\n.logo_icon p {\n    text-align: center;\n    color: #3D4F71; \n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n}\n\n.footer_Search .btn-primary {\n    border-radius: 0px 10px 10px 0px !important; \n    background: #163873 !important;\n    color: #FFF;\n    border: none;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    display: flex;\n    width: 150px;\n    height: 50px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n}\n\n.footer_Search .form-control {\n    height: 50px;\n    border-top-right-radius: unset;\n    border-bottom-right-radius: unset;\n    color: var(--Gray-1, #808282);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n}\n\n.input_group_footer {\n    max-width: 599px;\n}\n\n.footer_Search .btn:hover {\n    border: none;\n    background-color: #000;\n    color: #fff;\n}\n\n.footer_link h3 {\n    color: var(--Black, #010404);\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    text-transform: capitalize;\n}\n\n.footer_link ul {\n    padding: 0;\n    margin-top: 20px;\n}\n\n.footer_link ul li a {\n    color: #3D4F71;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 40px;\n    text-transform: capitalize;\n}\n\n.footer_bottom {\n    background: #B9CBEB;\n    height: 50px;\n}\n\n.footer_bottom span {\n    color: #163873;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n@media (max-width: 991.98px) {\n    .footer_bottom {\n        height: auto;\n        padding: 5px;\n    }\n\n    .footer_link {\n        text-align: center;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
